import React from 'react';
import { createRoot } from 'react-dom/client';

import '@montel/montelpro-shared-components/styles/index.scss';
import 'styles/globalThemes.scss';
import 'styles/grid.scss';
import AppProvider from './providers/AppProviders';
import App from './App';

const rootElement = document.getElementById('root');
if (rootElement) {
	const root = createRoot(rootElement);
	root.render(
		<AppProvider>
			<App />
		</AppProvider>,
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
// reportWebVitals(console.log);
